import Vue from 'vue';
import axios from 'axios';

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = 'http://107.174.145.151:2980/TPJ.svc/';
axios.defaults.headers.accept = 'application/json';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ''
  timeout: 60 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
};

const api = axios.create(config);

api.interceptors.request.use(
  // eslint-disable-next-line
  config => config, request => request, error => Promise.reject(error),
);

// Add a response interceptor
api.interceptors.response.use(
  response => response, error => Promise.reject(error),
);

Plugin.install = () => {
  Vue.axios = api;
  window.axios = api;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return api;
      },
    },
    $axios: {
      get() {
        return api;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
